module.exports = __webpack_public_path__ + "img/copy.db616e4.svg";